import React, {useCallback, useRef} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {Translation as T} from "@awe-web/shared/lib";
import {CmsOverlay} from "../../components/cms_overlay";

export default function TranslationWithCmsLink({className, pageName, code}) {
  const overlayRef = useRef();

  const openOverlay = useCallback((event) => {
    event.preventDefault();
    if (overlayRef.current) {
      overlayRef.current.open();
    }
  }, []);

  if (!pageName || pageName.length === 0) {
    return;
  }

  const combinedClassName = classnames("translation", className);

  return (
    <>
      <T className={combinedClassName} onLinkedTextClick={openOverlay} code={code} />
      <CmsOverlay ref={overlayRef} pageName={pageName} />
    </>
  );
}

TranslationWithCmsLink.propTypes = {
  className: PropTypes.string,
  code: PropTypes.string.isRequired,
  pageName: PropTypes.string
};
